export const kebabToCamelCase = (s: string) =>
  s.replace(/-./g, (x: string) => x[1].toUpperCase());
export const dotToCamelCase = (s: string) =>
  s.replace(/\../g, (x: string) => x[1].toUpperCase());
export const snakeToCamelCase = (s: string) =>
  s.replace(/_./g, (x: string) => x[1].toUpperCase());

export const camelToSnakeCase = (x: string) =>
  x.replace(/[A-Z]/g, (x) => `_${x.toLowerCase()}`);

export const camelToKebabCase = (x: string) =>
  x.replace(/[A-Z]/g, (x) => `-${x.toLowerCase()}`);

export const rtrim = (str: string, ch: string) => {
  let i = str.length;
  while (i-- && str.charAt(i) === ch);
  return str.substring(0, i + 1);
};

export function lowercaseFirst(str: string): string {
  if (!str) return str;
  return str.charAt(0).toLowerCase() + str.slice(1);
}
export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const doesntContainOnlyNumbers = (str: string) => {
  const anythingExceptNumber = /\D/;
  return anythingExceptNumber.test(str);
};

export const containsOnlyNumbers = (str: string) => {
  return !doesntContainOnlyNumbers(str);
};
